import React from "react"
import { Link } from "gatsby"
import { CSSTransition } from 'react-transition-group';

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  toggleMenu = () => {
    const currentState = this.state.active;
    this.setState({ active: !currentState });
  }

  render() {
    return (
      <React.Fragment>
      {/* <header>
        <section id="masthead">
          <article>
            <div className="CSUF">
              <p><a href="http://fullerton.edu/" target="_blank" rel="noopener noreferrer">California State University, Fullerton</a></p>
            </div>
          </article>
        </section>
      </header> */}
      <header id="story-header">
        <button aria-label="Menu" className={this.state.active ? 'hamburger hamburger--squeeze is-active': 'hamburger hamburger--squeeze'} type="button" id="hamburger" onClick={this.toggleMenu}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
          <span className="hamburger-text">Menu</span>
        </button>
        {/* <a href="http://www.fullerton.edu" id="branding_emblem"><img src="_assets/images/emblem.png" alt="CSUF" /></a> */}
        {/* <Link className="intro" id="story-title" to="/">Crime and Justice in the Borderlands</Link> */}
        {/* <a href="index.html" id="story-title">Crime and Justice in the Borderlands</a> */}
        <a href="http://www.fullerton.edu" id="branding">California State University, Fullerton</a>
        <nav id="top_nav">
          <ul>
            <li><Link activeClassName="active" to="/">Introduction</Link></li>
            <li><Link activeClassName="active" to="/mapping/">Mapping Quakes</Link></li>
            <li><Link activeClassName="active" to="/student/">Student Geologist</Link></li>
            <li><Link activeClassName="active" to="/alumni/">Geology Alumni</Link></li>
            <li><Link activeClassName="active" to="/be-prepared/">Be Prepared</Link></li>
          </ul>
        </nav>
      </header>
      <CSSTransition
      in={this.state.active}
      classNames={{
        enter: "animated",
        enterActive: "animated slideInDown open",
        enterDone: 'animated slideInDown open',
        exit: 'animated slideOutUp open',
        exitActive: 'animated slideOutUp open',
        exitDone: 'animated slideOutUp open'
      }}
      >
        <nav id="main_nav">
          <ul>
            <li><Link activeClassName="active" to="/">Introduction</Link></li>
            <li><Link activeClassName="active" to="/mapping/">Mapping Quakes</Link></li>
            <li><Link activeClassName="active" to="/student/">Student Geologist</Link></li>
            <li><Link activeClassName="active" to="/alumni/">Geology Alumni</Link></li>
            <li><Link activeClassName="active" to="/be-prepared/">Be Prepared</Link></li>
          </ul>
        </nav>
      </CSSTransition>
      </React.Fragment>
    );
  }
}